//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
import Coralogix from "./errorLoggers/CoralogixLogger";

const allLoggers = {
  general: console,
  coralogix: Coralogix,
};

class _errorLogger {
  constructor() {
    this.product_tag = null;
    this.store = null;
    this.mode = "defined";
  }

  async init(config, product_tag, store) {
    const mode = config.appConfig.campaign_properties.web_log_mode;
    this.mode = mode ? mode : this.mode;
    this.product_tag = product_tag;
    this.store = store;
    if (config.appConfig.env === "local" && !config.appConfig.logger.token) {
      this.logger = console;
      return;
    }

    if (this.mode === "off") {
      return;
    }

    try {
      // coralogix
      this.logger = new allLoggers["coralogix"](store);
      await this.logger.init(config.appConfig.coralogix_config);
    } catch (ex) {
      this.logger = allLoggers.general;
      console.warn(
        `${config.appConfig.logger.type} logger failed to init using console instead `
      );
      this.logger.log(ex);
    }
  }

  log(msg, product_tag = null) {
    if (this.mode === "off") {
      return;
    }
    let url = window.location.href;
    product_tag = !product_tag ? this.product_tag : product_tag;
    this.logger.log(msg, product_tag, url);
  }
}
const ErrorLogger = new _errorLogger();
export default ErrorLogger;
